module.exports = __webpack_public_path__ + "20230117/img/slide2_dui.70fbe93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide2_dui.png
// module id = TZ0N
// module chunks = 1